import { render, staticRenderFns } from "./authority.vue?vue&type=template&id=7d7ec78d&scoped=true"
import script from "./authority.vue?vue&type=script&lang=js"
export * from "./authority.vue?vue&type=script&lang=js"
import style0 from "./authority.vue?vue&type=style&index=0&id=7d7ec78d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7ec78d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d7ec78d')) {
      api.createRecord('7d7ec78d', component.options)
    } else {
      api.reload('7d7ec78d', component.options)
    }
    module.hot.accept("./authority.vue?vue&type=template&id=7d7ec78d&scoped=true", function () {
      api.rerender('7d7ec78d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administrators/authorityManage/authority.vue"
export default component.exports